import { http } from "@/lib/api";

export const SESSION_KEY = "ns_portal_token";

export const savePortalSession = ({ session_token }) => {
  if (session_token) localStorage.setItem(SESSION_KEY, session_token);
};

export const clearPortalSession = () => localStorage.removeItem(SESSION_KEY);

// Attach portal token as Bearer when calling portal endpoints (fallback when cookie is missing)
export const portalHttp = {
  get: (url, cfg = {}) => http.get(url, withPortalAuth(cfg)),
  post: (url, body, cfg = {}) => http.post(url, body, withPortalAuth(cfg)),
};

function withPortalAuth(cfg) {
  const tok = localStorage.getItem(SESSION_KEY);
  if (!tok) return cfg;
  return { ...cfg, headers: { ...(cfg.headers || {}), Authorization: `Bearer ${tok}` } };
}

// Builds Emergent OAuth redirect URL. We send user to Emergent, which lands them
// back at `${origin}/auth/callback#session_id=…`.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startGoogleLogin = (portalType) => {
  localStorage.setItem("ns_portal_type", portalType);
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};
